import React from 'react'
import CatalogueForm from '../form/CatalogueForm'
import { createCatalogue } from '../../../actions/cataloguesActions'
import { catalogueModel } from '../../../models/catalogueModel'
import { CATALOGUE_FORM } from '../../../services/forms'
import { change, isDirty, submit } from 'redux-form'
import FormTop from '../../form/FormTop'
import NavigationPrompt from '../../general/NavigationPrompt'
import { EditTop } from '../../general/EditTop'
import { loadProvenancePersons } from '../../../actions/provenancePersonsActions'
import { loadProvenanceInstitutions } from '../../../actions/provenanceInstitutionsActions'
import { loadArtworksForMentionsAction } from '../../../actions/artworksActions'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import DataProviderFunctional from '../../loader/DataProviderFunctional'

const CatalogueEditPresentation = () => {
  let match = useRouteMatch()
  const initialValues = catalogueModel
  const lang = useSelector((state) => state.translations.language)
  const saveState = useSelector((state) => state.keywords.saveState)
  const dirty = useSelector((state) => isDirty(CATALOGUE_FORM)(state))
  const dispatch = useDispatch()
  const onSubmit = (data) => dispatch(createCatalogue(data))
  const changeFieldValue = (field, value) => dispatch(change(CATALOGUE_FORM, field, value))
  const changeLanguage = (language) => () => dispatch(changeLanguage(language))
  const remoteSubmit = () => dispatch(submit(CATALOGUE_FORM))

  return (
    <div>
      <div className="Catalogue-controls">
        <EditTop title="Create Catalogue" />
        <div className="controls row">
          <FormTop title="" button="Save catalogue" remote={remoteSubmit} saveState={saveState} />
        </div>
      </div>

      <div className="exhbition-grid">
        <NavigationPrompt when={dirty} />
        <CatalogueForm
          lang={lang}
          onSubmit={onSubmit}
          changeFieldValue={changeFieldValue}
          initialValues={initialValues}
          match={match}
        />
      </div>
    </div>
  )
}

const CatalogueCreate = () => {
  const loading = useSelector(state => state.catalogues.state)
  const error = useSelector((state) => state.catalogues.error)
  const dispatch = useDispatch()
  const load = () => {
    dispatch(loadProvenancePersons())
    dispatch(loadProvenanceInstitutions())
    dispatch(loadArtworksForMentionsAction())
  }
  return (
    <DataProviderFunctional
      error={error}
      load={load}
      loading={loading}
      component={CatalogueEditPresentation}
    />
  )
}

export default CatalogueCreate
